import { render, staticRenderFns } from "./SettingsAuth.vue?vue&type=template&id=0512f009&"
import script from "./SettingsAuth.vue?vue&type=script&lang=ts&"
export * from "./SettingsAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports